import { type JSX } from "react";
import { RouteObject, redirect } from "react-router";

import { TrainingPage } from "./pages";
import PageError from "@/shared/ui/errors/PageError";
import * as Sentry from "@sentry/react";

const wrapWithSentry = (Component: JSX.Element) => (
	<Sentry.ErrorBoundary
		fallback={(fallbackProps) => (
			<PageError
				error={fallbackProps.error}
				componentStack={fallbackProps.componentStack}
				reset={() => {
					fallbackProps.resetError();
				}}
			/>
		)}
	>
		{/* <Suspense fallback={null /* or <TrainingPageSkeleton /> */}
		{Component}
		{/* </Suspense> */}
	</Sentry.ErrorBoundary>
);

export const trainingRoutes: RouteObject = {
	path: "/training/*",
	element: wrapWithSentry(<TrainingPage />),
	children: [
		{
			index: true,
			loader: () => redirect("/training/dashboard"),
		},
		{
			path: "dashboard",
			element: wrapWithSentry(<TrainingPage tabIndex={0} />),
		},
		{
			path: "courses/*",
			children: [
				{
					index: true,
					element: wrapWithSentry(<TrainingPage tabIndex={1} />),
				},
				{
					path: ":courseId/*",
					children: [
						{
							index: true,
							element: wrapWithSentry(<TrainingPage tabIndex={1} />),
						},
						{
							path: "archive",
							element: wrapWithSentry(<TrainingPage tabIndex={3} />),
						},
						{
							path: "sessions/:sessionId",
							element: wrapWithSentry(<TrainingPage tabIndex={1} />),
						},
					],
				},
			],
		},
		{
			path: "drills/*",
			children: [
				{
					index: true,
					element: wrapWithSentry(<TrainingPage tabIndex={2} />),
				},
				{
					path: ":drillId/*",
					children: [
						{
							index: true,
							element: wrapWithSentry(<TrainingPage tabIndex={2} />),
						},
						{
							path: "sessions/:sessionId",
							element: wrapWithSentry(<TrainingPage tabIndex={2} />),
						},
						{
							path: "ArchivedSessions",
							element: wrapWithSentry(<TrainingPage tabIndex={3} />),
						},
					],
				},
			],
		},
		{
			path: "archive/*",
			children: [
				{
					index: true,
					element: wrapWithSentry(<TrainingPage tabIndex={3} />),
				},
				{
					path: "kpiParameters/:kpiParameterId",
					element: wrapWithSentry(<TrainingPage tabIndex={3} />),
				},
				{
					path: ":sessionId",
					element: wrapWithSentry(<TrainingPage tabIndex={3} />),
				},
			],
		},
		{
			path: "planner/*",
			children: [
				{
					index: true,
					element: wrapWithSentry(<TrainingPage tabIndex={4} />),
				},
			],
		},
	],
};
